module.exports = __webpack_public_path__ + "media/images/logo-b16a5de958fcfddaff6fa2aaa9719cdc.png";